import Vue from 'vue'
import MocHeader from './components/MocHeader.vue'
import MocFooter from './components/MocFooter.vue'
import MocSpSlideMenu from './components/MocSpSlideMenu.vue'
import './js/moc_header_overlay.js'
import './js/moc_switch_owner.js'

const {
  mypageRootPath,
  noLogin,
  isMgGroupMember,
  clName,
  buildingName,
  buildingType,
  changeInfoUrl,
  energyPage,
  mansionName,
  isVisibleLinkgates,
  isVisibleMPoint,
  current,
  other_owners,
  primal_oid } = window.MOC.LoginInfo
const isApp = window.navigator.userAgent.match(/MOCapp/)

const props = {
  mypageRootPath,
  noLogin,
  changeInfoUrl,
  clName,
  buildingName,
  isMgGroupMember,
  buildingType,
  isApp,
  energyPage,
  mansionName,
  isVisibleLinkgates,
  isVisibleMPoint,
  current,
  other_owners,
  primal_oid
}

let header = null
let footer = null

if (!document.querySelector('body[data-member-type]')) {
  const type = buildingType == 1 ? 'reform' : 'kodate'
  document.querySelector('body').setAttribute('data-member-type', type)
}

if (document.getElementById('moc-header')) {
  header = new Vue({
    el: '#moc-header',
    components: { MocHeader },
    render: h => h(MocHeader, { props })
  })
}

if (document.getElementById('moc-footer')) {
  header = new Vue({
    el: '#moc-footer',
    components: { MocFooter },
    render: h => h(MocFooter, { props })
  })
}

if (document.getElementById('moc-sp-slide-menu')) {
  header = new Vue({
    el: '#moc-sp-slide-menu',
    components: { MocSpSlideMenu },
    render: h => h(MocSpSlideMenu, { props })
  })
}

export default { header, footer }



// WEBPACK FOOTER //
// ./src/main.js